<template>
    <v-chip small>
        <v-avatar>
            <img :src="datos[empresa].avatar">
        </v-avatar>
        {{ datos[empresa].name }}
    </v-chip>
</template>
<script>
    export default {
        name: 'empresa-chip',
        props: ['empresa'],
        data() {
            return {
                datos: {
                    1: {id: 1, name: 'Friolatina', avatar: './img/iso-1.svg'},
                    2: {id: 2, name: 'Bervill', avatar: './img/iso-2.svg'},
                    3: {id: 3, name: 'Acerolatina', avatar: './img/iso-3.svg'},
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/EmpresaChip.vue